import { useState, useEffect } from 'react';
import axios from 'axios';
import { Database, Loader2 } from 'lucide-react';
import { API, getAuthHeaders } from '../../utils/adminAuth';

export default function StorageUsageWidget() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/storage/usage`, { headers: getAuthHeaders() })
      .then(r => { setData(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bg-[#141414] border border-white/5 p-4 sm:p-6">
        <Loader2 className="w-4 h-4 text-[#D4AF37] animate-spin" />
      </div>
    );
  }
  if (!data) return null;

  const ROW_LABELS = {
    product_main_images: 'Product main images',
    product_gallery_images: 'Product gallery images',
    team_member_photos: 'Team member photos',
    collection_covers: 'Collection covers',
    review_photos: 'Review photos',
    hero_banner: 'Hero banner',
    payment_qr_codes: 'Payment QR codes',
  };

  return (
    <div className="bg-[#141414] border border-white/5 p-4 sm:p-6" data-testid="storage-usage-widget">
      <div className="flex items-center gap-2 mb-3">
        <Database className="w-4 h-4 text-[#1C7D3F]" />
        <p className="text-white text-sm font-sans font-medium">Storage Usage</p>
      </div>
      <p className="text-white/40 text-xs font-sans mb-4">
        Total files referenced: <span className="text-white font-medium">{data.total_files_referenced}</span>
      </p>
      <div className="space-y-1.5">
        {Object.entries(data.breakdown).map(([k, v]) => (
          <div key={k} className="flex items-center justify-between text-xs font-sans">
            <span className="text-white/60">{ROW_LABELS[k] || k}</span>
            <span className="text-white font-mono">{v}</span>
          </div>
        ))}
      </div>
      <p className="text-white/30 text-[10px] font-sans mt-4">
        Old files are auto-deleted on update or removal — no orphan files clutter your storage.
      </p>
    </div>
  );
}
